import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { captureFrontException } from './lib/sentry';
import './index.css';

// Global error handlers : capture les promesses rejetées + erreurs non-catchées
if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (e) => {
    void captureFrontException(e.reason, { tags: { source: 'unhandledrejection' } });
  });
  window.addEventListener('error', (e) => {
    if (e.error) void captureFrontException(e.error, { tags: { source: 'window.error' } });
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
);
